import React from "react";
import Button from "../../shared/Button";
import Zoom from "react-reveal/Zoom";
import PropTypes from "prop-types";

import { useSelector } from "react-redux";

function Samples({ onScroll, authenticated = false }) {
  const recent_samples = useSelector(state => state.recent_samples);

  function render_image(img, key) {
    return (
      <Zoom key={key}>
        <div className="pw-samples-container--image-container">
          <img src={img} alt="" />
        </div>
      </Zoom>
    );
  }

  if (recent_samples.loaded) {
    return (
      <div className="pw-samples-container">
        <div className="pw-samples-container--inner">
          <div className="pw-row">
            <div className="pw-col-6">
              <h1 className="pw-samples-container--title">
                Recent samples trialed
              </h1>
              <p className="pw-samples-container--subtitle">
                We have ‘NEW’ and exciting samples available each month to our
                members. Free samples in exchange for your honest feedback… why
                wait?
              </p>
              {console.log("authenticated: ", authenticated)}
              {authenticated ? null : (
                <div className="pw-samples-container--btn-container">
                  <Button
                    className="pw-samples-container--btn"
                    label="SIGN UP TODAY"
                    onClick={onScroll}
                  />
                </div>
              )}
            </div>

            <div className="pw-col-6">
              <div className="pw-samples-container--main-image-container">
                {Object.values(recent_samples.images)
                  .slice(0, 3)
                  .map(image => render_image(image.image.url, image.priority))}
              </div>

              <div className="pw-samples-container--main-image-container">
                {Object.values(recent_samples.images)
                  .slice(3, 7)
                  .map(image => render_image(image.image.url, image.priority))}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return <div>Loading</div>;
  }
}

export default Samples;

Samples.propTypes = {
  onScroll: PropTypes.func
};
